module.exports = __webpack_public_path__ + "img/social-facebook-button-blue-icon.a1b1f1dd.png";